/** Gabay sa Paggamit (`/w/:ws/guide`): page chrome lang. Ingles ang nilalaman ng mga topic. */
export const guide = {
  title: "Gabay sa Paggamit",
  subtitle: "Hakbang-hakbang na tulong sa lahat ng nasa Sagot. Maghanap, o mag-browse ayon sa bahagi.",
  searchLabel: "Maghanap sa gabay",
  searchPlaceholder: "Maghanap, hal. “mag-upload ng file”",
  searchClear: "Burahin ang hinahanap",
  developerDocs: "Docs para sa developer",
  modulesLabel: "Mga bahagi ng gabay",
  moduleSelect: "Bahagi",
  allTopics: "Lahat ng topic",
  topicCount_one: "{{count}} topic",
  topicCount_other: "{{count}} topic",
  stepCount_one: "{{count}} hakbang",
  stepCount_other: "{{count}} hakbang",
  resultsFor_one: "{{count}} topic ang tumutugma sa “{{query}}”",
  resultsFor_other: "{{count}} topic ang tumutugma sa “{{query}}”",
  resultsHeading: "Mga resulta ng paghahanap",
  noResultsTitle: "Walang tumutugma sa “{{query}}”",
  noResultsBody: "Suriin ang spelling, gumamit ng mas kaunti o mas simpleng salita, o mag-browse ayon sa bahagi.",
  noResultsInModule: "Walang topic sa {{module}} na tumutugma sa “{{query}}”. Subukan ang lahat ng bahagi.",
  clearSearch: "Burahin ang hinahanap",
  showAllAreas: "Hanapin sa lahat ng bahagi",
  suggestionsHeading: "Magandang simulan dito",
  emptyTitle: "Parating na ang gabay",
  emptyBody: "Lalabas dito ang mga hakbang-hakbang na gabay. Samantala, saklaw ng docs para sa developer ang API.",
  notFoundTitle: "Hindi namin nahanap ang gabay na iyon",
  notFoundBody: "Maaaring pinalitan ang pangalan nito. Hanapin ang kailangan mo, o mag-browse ayon sa bahagi.",
  backToGuide: "Bumalik sa Gabay sa Paggamit",
  breadcrumb: "Daan sa gabay",
  audienceLabel: "Sino ang puwedeng gumawa nito",
  planBadge: "Planong {{plan}} pataas",
  before: "Bago ka magsimula",
  steps: "Mga hakbang",
  stepLabel: "Hakbang {{n}}",
  result: "Ano ang makikita mo",
  tips: "Mga tip",
  related: "Mga kaugnay na gabay",
  pagerLabel: "Iba pa sa bahaging ito",
  previous: "Nauna",
  next: "Susunod",
  openPage: "Buksan ang {{page}}",
  enlarge: "Palakihin ang screenshot: {{alt}}",
  shotDialogTitle: "Screenshot ng hakbang {{n}}",
  shotUnavailable: "Hindi ma-load ang screenshot na ito.",
  paletteGroup: "Gabay sa Paggamit",
  loadingLabel: "Naglo-load ang gabay",
} as const;
